import * as React from "react";
import { Dialog } from 'primereact/dialog';
import { EditorComponent } from "../EditorComponent";
import { NewButton } from "../synced/ui/NewButton/NewButton";


interface CommentButtonProps {
  label: string;
  className: string;
  icon: string;
  commentIsRequired: boolean;
  disabled: boolean;
  action: (comment: string) => void;
}

export const CommentButton: React.FC<CommentButtonProps> = ({ label, className, icon, commentIsRequired, disabled, action }) => {
  const [commentDialogIsVisible, setCommentDialogIsVisible] = React.useState<boolean>(false);
  const [comment, setComment] = React.useState<string>("");
  const [defaultComment, setDefaultComment] = React.useState<string>("");
  const onCommentChange = (e) => setComment(e.htmlValue ?? ``);


  const hide = () => {
    setCommentDialogIsVisible(false);
    setComment("");
  }

  const send = React.useCallback(() => {
    action(comment);
    hide();
  }, [comment, action]);


  const footerTemplate = (
    <div className="pd-dialog-footer">
      <NewButton variant="secondary" icon="fa-solid fa-xmark" onClick={hide}>Отмена</NewButton>
      <NewButton variant="primary" icon="fa-solid fa-paper-plane" disabled={commentIsRequired && comment.length === 0} onClick={send}>Отправить</NewButton>
    </div>
  );

  return (
    <React.Fragment>
      <NewButton
          variant={'primary'}
        className={className}
        disabled={disabled}
        onClick={() => setCommentDialogIsVisible(true)} >
          <i className={icon} />
          {label}
      </NewButton>
      {
        commentDialogIsVisible &&
        <Dialog
          blockScroll
          header="Введите комментарий"
          visible={commentDialogIsVisible}
          className="pd-dialog"
          style={{ width: '900px' }}
          onHide={hide}
          footer={footerTemplate}>
          <EditorComponent
            value={defaultComment}
            onTextChange={onCommentChange}
            className="w-100 mb-1"
            style={{ height: `50vh` }} />
        </Dialog>
      }
    </React.Fragment>
  );
}
